export const ActionTypes = {
  //auth
  SET_USER: 'SET_USER',
  REMOVE_USER: 'REMOVE_USER',
  TOGGLE_SIDENAV: 'TOGGLE_SIDENAV',
  AUTH_LOADING: 'AUTH_LOADING',
  REGISTER_SUCCESS: 'REGISTER_SUCCESS',
  REGISTER_FAIL: 'REGISTER_FAIL',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAIL: 'LOGIN_FAIL',
  SET_FIRST_LOGIN: 'SET_FIRST_LOGIN',
  SET_FIRST_LOGIN_SUCCESS: 'SET_FIRST_LOGIN_SUCCESS',
  SET_FIRST_LOGIN_FAIL: 'SET_FIRST_LOGIN_FAIL',
  LOGOUT: 'LOGOUT',

  //catelog
  SET_CATALOG: 'SET_CATALOG',
  UPDATE_CATELOG: 'UPDATE_CATELOG',
  SET_CATALOG_COUNT: 'SET_CATALOG_COUNT',
  MANAGE_CATALOG_FORM_LOADING: 'MANAGE_CATALOG_FORM_LOADING',
  MANAGE_CATALOG_FORM_FAILURE: 'MANAGE_CATALOG_FORM_FAILURE',
  MANAGE_CATALOG_FORM_SUCCESS: 'MANAGE_CATALOG_FORM_SUCCESS',
  MANAGE_CATALOG_BRAND_FORM_SUCCESS: 'MANAGE_CATALOG_BRAND_FORM_SUCCESS',
  SET_CATALOG_FORM_EDITABLE: 'SET_CATALOG_FORM_EDITABLE',
  FETCH_CATALOG_DETAILS_LOADING: 'FETCH_CATALOG_DETAILS_LOADING',
  FETCH_CATALOG_DETAILS_SUCCESS: 'FETCH_CATALOG_DETAILS_SUCCESS',
  FETCH_CATALOG_DETAILS_FAILURE: 'FETCH_CATALOG_DETAILS_FAILURE',
  RESET_CATALOG: 'RESET_CATALOG',
  GET_DROPDOWN_DATA: 'GET_DROPDOWN_DATA',
  GET_INDUSTRY: 'GET_INDUSTRY',
  GET_BUSSINESS_CATEGORY_DATA: 'GET_BUSSINESS_CATEGORY_DATA',
  GET_BUSSINESS_TYPE_DATA: 'GET_BUSSINESS_TYPE_DATA',
  SET_BRAND_USER: 'SET_BRAND_USER',
  GET_PROFILE: 'GET_PROFILE',
  FETCH_COUNTRIES: 'FETCH_COUNTRIES',
  FETCH_STATES: 'FETCH_STATES',
  FETCH_CITIES: 'FETCH_CITIES',
  //publish catalog
  PUBLISH_CATALOG_LOADING: 'PUBLISH_CATALOG_LOADING',
  PUBLISH_CATALOG_SUCCESS: 'PUBLISH_CATALOG_SUCCESS',
  PUBLISH_CATALOG_FAILURE: 'PUBLISH_CATALOG_FAILURE',
  FETCH_ZONES: 'FETCH_ZONES',
  GET_COST_BIFURCATION_DATA: 'GET_COST_BIFURCATION_DATA',
  GET_EMPLOYEE_DETAILS_DATA: 'GET_EMPLOYEE_DETAILS_DATA',
  GET_LICENSE_TYPE_DATA: 'GET_LICENSE_TYPE_DATA',

  //catelog views
  FETCH_CATEGLOG_VIEWS_LIST: 'FETCH_CATEGLOG_VIEWS_LIST',
  UPDATE_CATEGLOG_VIEWS_BYID_SHORTLIST: 'UPDATE_CATEGLOG_VIEWS_BYID_SHORTLIST',
  SET_KEYWORD_MAPPING_TITLE: 'SET_KEYWORD_MAPPING_TITLE',
};
